import React from 'react';
import { _useApplicationPermissions } from '../hooks/useApplicationPermissions';
import { usePendingUsersInternal } from '../hooks/usePendingUsers';
import { useActiveUsersInternal } from '../hooks/useActiveUsers';

export interface UserManagementStateType {
  applicationState: ReturnType<typeof _useApplicationPermissions>;
  pendingUsersState: ReturnType<typeof usePendingUsersInternal>;
  activeUsersState: ReturnType<typeof useActiveUsersInternal>;
}

export const UserManagementStateContext = React.createContext<UserManagementStateType | undefined>(undefined);

export type UserManagementStateProviderProviderProps = {
  children?: React.ReactNode | JSX.Element;
};

export const UserManagementStateProvider = ({ children }: UserManagementStateProviderProviderProps) => {
  const applicationState = _useApplicationPermissions();
  const pendingUsersState = usePendingUsersInternal();
  const activeUsersState = useActiveUsersInternal();

  const appState = React.useMemo(() => {
    return { applicationState, pendingUsersState, activeUsersState };
  }, [applicationState, pendingUsersState, activeUsersState]);

  return <UserManagementStateContext.Provider value={appState}>{children}</UserManagementStateContext.Provider>;
};
